/**
 * Provides the current experiment or -1 if no provider was initialised or an error occurred retrieving an experiment value
 *
 */

define([], ()=> {

    let useGoogle;
    return {

        useGoogleProvider: (useGoogleProviderFlag) => {
            useGoogle = useGoogleProviderFlag;
        },

        $get: ['gwDemoGuidewireExperiment', 'gwGoogleExperiment', (gwDemoGuidewireExperiment, gwGoogleExperiment)=> {
            const adapterProvider = (useGoogle) ? gwGoogleExperiment : gwDemoGuidewireExperiment;

            return {
                /**
                 * @param [params] {Object}
                 * @returns {Promise}
                 */
                getExperimentValue(experiment, params) {
                    return adapterProvider.getExperimentValue(experiment, params);
                }
            };
        }]
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/abexperiment/AbExperimentService.js